export default "__VITE_ASSET__BSudrkr6__"